import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import TaxAmnestyContent from './TaxAmnestyContent';

const form = {
  q: '',
};

function TaxAmnestyContainer({
  match,
  history,
  getTaxAmnestyList,
  taxAmnestyList,
  isLoading,
  taxAmnestyListPager,
  deleteTaxAmnesty,
  getSingleTaxAmnesty,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Tax Amnesty',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();

    const args = {
      ...data.attributes,
      effectivity_start: moment(
        _.get(data, 'attributes.effectivity_start')
      ).format('MM/DD/YYYY'),
      effectivity_end: moment(_.get(data, 'attributes.effectivity_end')).format(
        'MM/DD/YYYY'
      ),
    };

    setModal({
      isOpen: true,
      content: <UpdateModal updateList={args} id={data.id} />,
      title: 'Update Tax Amnesty',
      modalSize: 'modal-md',
    });
  };

  const handleDelete = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this calculations?',
      () => {
        deleteTaxAmnesty(data.id, () => {
          getTaxAmnestyList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/bpls/settings/tax-amnesty/${id}`);
            getSingleTaxAmnesty(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getTaxAmnestyList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.q,
    sort_by: 'asc',
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getTaxAmnestyList({ q: formData.q, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <Route
      path={`${match.path}/:taxAmnestyId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Tax Amnesty"
          getData={getTaxAmnestyList}
          setParams={param}
          setKeyword={handleOnChange}
          keyword={_.get(formData, 'q') || ''}
          keywordPlaceholder="Search..."
          pathName={`${match.path}/:taxAmnestyId?`}
          listName="taxAmnesty"
          label="Tax Amnesty"
          renderItem={(item) => (
            <div className="p-3">{_.get(item, 'attributes.name')}</div>
          )}
          isLoading={isLoading}
          selected={params.taxAmnestyId}
          data={taxAmnestyList}
          dataPager={taxAmnestyListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:taxAmnestyId?`}
                  render={() => (
                    <TaxAmnestyContent
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      handleDelete={handleDelete}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:taxAmnestyId?`}
                render={() =>
                  !params.taxAmnestyId && taxAmnestyList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(taxAmnestyList, '0.id')}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
        />
      )}
    />
  );
}

TaxAmnestyContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTaxAmnestyList: PropTypes.instanceOf(Function).isRequired,
  taxAmnestyList: PropTypes.instanceOf(Array).isRequired,
  taxAmnestyListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  deleteTaxAmnesty: PropTypes.instanceOf(Function).isRequired,
  getSingleTaxAmnesty: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxAmnestyList: _.get(api, `${c.GET_TAX_AMNESTY}.list`) || [],
  taxAmnestyListPager: _.get(api, `${c.GET_TAX_AMNESTY}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_TAX_AMNESTY) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxAmnestyContainer);
